import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  Row,
  Col,
  Layout,
} from "antd";
import { LocationPinIcon, MyEventIcon } from "../../assets/CustomIcon";

import PageLayout from "../../components/common/Layouts/PageLayout";
import PieChart from "../../components/Dashboard/PieChart";
import { fetchDashboardCounts, selectDashboardCountsStatus } from "../../redux/dashboardSlice";

const { Content } = Layout;

export default function Dashboard() {
  const dispatch = useDispatch();
  const { counts } = useSelector((state) => state.dashboard);
  const countsStatus = useSelector((state) => selectDashboardCountsStatus(state));

  useEffect(() => {
    dispatch(fetchDashboardCounts());
  }, [dispatch]);

  const statsData = [
    {
      title: "Listed Events",
      value: counts.events,
      icon: <MyEventIcon />,
      colorClass: "pink",
    },
    {
      title: "Listed Venues",
      value: counts.venues,
      icon: <LocationPinIcon />,
      colorClass: "blue",
    },
    {
      title: "Contacts",
      value: counts.contacts,
      icon: <LocationPinIcon />,
      colorClass: "blue",
    },
    {
      title: "Tickets",
      value: counts.tickets,
      icon: <LocationPinIcon />,
      colorClass: "blue",
    },
  ];

  return (
    <PageLayout title="Dashboard">
      <Content>
        <section className="statSec">
          <Row gutter={[20, 20]}>
            {statsData.map((stat, index) => (
              <Col xs={24} sm={12} lg={6} key={index}>
                <Card hoverable className="statCard">
                  <div className="statCardContent">
                    <div className={`statIcon ${stat.colorClass}`}>
                      {stat.icon}
                    </div>
                    <div className="stat-info">
                      <div className="statLabel">{stat.title}</div>
                      <div className="statValue">{stat.value}</div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </section>
        {countsStatus === 'succeeded' && (
          <section className="pieChartSec">
            <PieChart pieChartData={statsData.map(stat => ({ type: stat.title, value: stat.value }))}/>
          </section>
        )}
      </Content>
    </PageLayout>
  );
}
